// RGB color type

export type RGBColor = {
  alpha: number // alpha (0-1)
  blue: number // blue (0-1)
  green: number // green (0-1)
  red: number // red (0-1)
}
